<template>
     <modal class="guangMingAiHuModel" :isShow="isShow" @keyup.esc="hide" v-readCard @barcode="barcode">
        <div class="header">爱护网折扣<span class="close" @click="hide()">×</span></div>
        <div class="The-head">
            请刷银行卡:
            <div class="from-input" >
                <input type="text" v-model="idCode" readonly/>
            </div>
            <button class="btn" @click="onMemberInfo()">查询</button>
        </div>
        <div class="modal-body">
            <div class="info-box">
                <div class="title">1.爱护网客户信息</div>
                <div class="tr-li">
                    <div class="flex-1">姓名：<span class="lable-text" v-show="aiHuMeberInfo">{{aiHuMeberInfo?.MemberName}}</span></div>
                    <div class="flex-1">性别：<span class="lable-text" v-show="aiHuMeberInfo">{{aiHuMeberInfo?.Gender==0?'男':'女'}}</span></div>
                </div>
            </div>
            <div class="describe-box">优惠说明：<span class="red" v-show="aiHuMeberInfo">本订单客户可享受优惠,立减￥<span class="money">{{aiHuMeberInfo?.CardKind_DiscountRate||0}}</span></span></div>
            <div class="info-box">
                <div class="title">2.爱护网绑定的会员资料</div>
                <div class="tr-li">
                    <div class="flex-1">会员卡号：<span class="lable-text">{{meberInfo?.Card_No}}</span></div>
                    <div class="flex-1">会员等级：<span class="lable-text">{{meberInfo?.Bestech_Card_KindName}}</span></div>
                    <div class="flex-1">姓名：<span class="lable-text">{{meberInfo?.MemberName}}</span></div>
                </div>
                <div class="tr-li">
                    <div class="flex-1">
                        手&nbsp;机&nbsp;号&nbsp;：<span class="lable-text" v-if="meberInfo">{{$global.phonePrivacy(meberInfo?.Mobile)}}</span>
                    </div>
                    <div class="flex-1">
                        性 &nbsp; &nbsp; &nbsp; 别：<span class="lable-text" v-if="meberInfo?.Gender>-1">{{meberInfo?.Gender==0?'男':'女'}}</span>
                    </div>
                    <div class="flex-1">生日：<span class="lable-text">{{meberInfo?.Birthday}}</span></div>
                </div>
                <div class="tr-li">
                    <div class="flex-1">
                        余 &nbsp; &nbsp; &nbsp; 额：<span class="lable-text number" v-if="meberInfo?.Card_Money>0" >{{Number(meberInfo.Card_Money)}}</span>
                        <span style="color: red;"  v-if="meberInfo?.Gift_Money>0" >（赠{{Number(meberInfo.Gift_Money)}}）</span>
                    </div>
                    <div class="flex-1">
                        可&nbsp; 用 &nbsp;券：<span class="lable-text number">{{meberInfo?.Live_CouponsNum}}</span>
                        <span style="color: red;padding-left:5px;" v-if="meberInfo?.Live_CouponsNum">张</span>
                    </div>
                    <div class="flex-1">积分：<span class="lable-text number"  v-if="meberInfo?.Card_PilePoint>0">{{Number(meberInfo.Card_PilePoint)}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="bind()">去绑定会员</button>
            <button class="btn btn-confirm" @click="confirm()" v-throttle>确定折扣</button>
        </div>
        <!--绑定会员卡-->
        <modal-load :isShow="bindShow" isUnload>
            <bind-member-Model :isShow="bindShow" :aiHuCardNo="aiHuMeberInfo?.Card_No"
                @close="bindShow=false" 
                @confirm="bindConfirm"/>
        </modal-load>
    </modal>
</template>

<script>
import bindMemberModel from './bindMemberModel/bindMemberModel.vue'
export default {
    components:{
        bindMemberModel,
    },
    emits:["close","discountConfirm"],
    props:{
        isShow:{
            type:Boolean
        },
        /**所点菜品 */
        orderMenuList:{
            type:Object
        },
    },
    data(){
        return {
            //卡号
            idCode:"",
            //爱护网会员信息
            aiHuMeberInfo:null,
            //会员信息
            meberInfo:null,
            //绑卡弹层
            bindShow:false
        }
    },
    mounted(){
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        /**读卡 */
        barcode(e){
            if(e?.detail){
                this.idCode=e?.detail;
                this.onMemberInfo();
            }
        },
        /**读卡 */
        onMemberInfo(){
            this.idCode =this.idCode.replace(/[;,；,=,＝,?,？]/g,"");
            if(!this.idCode){
                this.$message.warning('查询码不能为空');
                return
            }
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
            let ConsumeList=[]
            let _memberorderInfo= JSON.parse(JSON.stringify(this.orderMenuList))
            _memberorderInfo.forEach(order=>{
                let item={
                    Eat_ConsumeID:order.Eat_ConsumeID,
                    Eat_XFBMID:order.EAT_XFBMID,
                    Eat_XFBMName:order.EAT_XFName,
                    Eat_Number:order.Eat_Number,
                    Eat_Price:order.Eat_SalePrice, //折前价格
                    Eat_ZkPrice:order.Eat_CheckPrice,//折扣后的价格
                    Eat_VipPrice:order.Eat_VipPrice//会员价
                }
                ConsumeList.push(item)
            })
            let param={
                User_ID:this.userInfo?.User_ID,  //用户id
                DynamicNo:this.idCode,
                Card_AutoID:'',
                Card_SN:'',
                Member_Type:28,//爱护网
                Need_CheckBillMoney:true,/**是否在读卡时核算账单消费优惠金额 */
                OrderConsumes:ConsumeList, //核算账单优惠时，请求时传入账单菜品明细 
            };
            const loading = this.$loading({
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.1)",
            });
            console.log(param)
            this.$httpAES.post("Bestech.CloudPos.GetMemberInfo",param).then((data)=>{
                loading.close();
                console.log(data);
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                    this.idCode=''
                }else{
                    if(data.ResponseBody?.length>0){
                        this.aiHuMeberInfo=data.ResponseBody.find(it=>it.Member_Sys==28);//28：爱护网
                        this.meberInfo=data.ResponseBody.find(it=>it.Member_Sys==2);//2：正品CRM3.0 会员
                    }
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        },
        /**绑卡 */
        bind(){
            if(!this.aiHuMeberInfo){
                this.$message.warning("请先刷卡读取会员信息！");
                return;
            }
            this.bindShow=true;
        },
        /**绑卡成功回调 */
        bindConfirm(meberInfo){
            this.meberInfo=meberInfo;
            this.bindShow=false;
        },
        /**确定折扣 */
        confirm(){
            if(!this.aiHuMeberInfo){
                this.$message.warning("请先刷卡读取会员信息！");
                return;
            }
            if(this.aiHuMeberInfo.CardKind_DiscountRate==0){
                this.$message.warning("本订单客户没有优惠！");
                return;
            }
            let _orderConsumes=[];
            this.orderMenuList?.forEach((item)=>{               
                if(item.Food_Status==-1 && !item.is_taste){
                    let SizeNumber = Number(item?.AssSizeNumber)
                    let Food_Types =1;
                    let _seep= item.Food_Speed
                    if(item.Food_Speed=='' || item.Food_Speed==null){
                        _seep='即'
                    }
                    if(item.FoodSetmeals!=null){
                        Food_Types=2
                        SizeNumber=0
                    }
                    if(item.DiyTcType){
                        Food_Types=item.DiyTcType
                    }
                    let orders ={
                        Food_ID:item.EAT_XFBMID,
                        Food_Code:item.EAT_XFCode,
                        Food_Type:Food_Types,
                        Food_Speed:_seep,
                        Food_Size:item.Eat_XFSize,
                        Food_Number:item.Eat_Number,
                        Food_Price:item.Eat_SalePrice,
                        Food_CheckPrice:item.Eat_CheckPrice,
                        FoodModifys:item.FoodModifys,
                        FoodSetmeals:item.FoodSetmeals,
                        Food_Name:item?.EAT_XFName,
                        Food_AssNumber:SizeNumber,
                        Eat_ConsumeID:item.Eat_ConsumeID
                    };
                    _orderConsumes.push(orders);
                } 
            })
            if(_orderConsumes.length==0){
                this.$message.warning("没有可折扣的菜品,请先去点菜");
                return;
            }
            let param={
                User_ID:this.userInfo?.User_ID,
                Operator_Name:this.userInfo?.Login_Name,
                Member_sys:28,//爱护网
                Kind:5,//1：折扣方案，5：金额折扣 ，3：全单折扣，4：单品折扣
                DiscountScheme_AutoID:"28",
                DiscountScheme_ZkMoney:this.aiHuMeberInfo.CardKind_DiscountRate,
                ThirdOrgExtendInfo:this.aiHuMeberInfo.ThirdOrgExtendInfo,
                OrderConsumes:_orderConsumes,
            }
            const loading = this.$loading({
                text: "折扣提交中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$httpAES.post("Bestech.CloudPos.DealWithTheSnackDiscount",param).then((data)=>{
                console.log(data)
                loading.close();
                if(data.ResponseHeader.ResultCode!=0){
                    this.$message.error(data.ResponseHeader.ResultDesc);
                }else{
                    this.$message.success({ message: "折扣计算完成"});
                    
                    this.$emit("discountConfirm",data,this.meberInfo);
                }
            }).catch((e)=>{
                loading.close();
                this.$alert(e.message, "提示", {confirmButtonText: "确定"});
            })
        }
    }
}
</script>

<style lang="sass">
@import "./guangMingAiHuModel.scss";
</style>